<tt-page *ngIf="!!inputListLanguages">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input *ngFor="let item of inputListLanguages" [ttLabel]="item.language_name" [(ttModel)]="item.textilemodelcategory4lang_name"></tt-input>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <div ng-repeat="item in vm.model.inputListLanguages">
            <tt-input class="col-xs-12 sp-0" tt-label="{{item.language_name}}" tt-model="item.textilemodelcategory4lang_name" tt-change="item.textilemodelcategory4lang_name = $value" tt-placeholder=""></tt-input>
        </div>

        <tt-button-save class="col-xs-12 sp-0" tt-text="save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>
</tt-page>-->
